module.exports = require('./getViewportSizeProvider')(window);
